import { forwardRef, type LegacyRef } from 'react';
import { useNavigate } from 'react-router-dom';
import assert from 'assert';
import FilteredSites from './FilteredSites';
import StateDecorator from '../../../components/utils/state/StateDecorator';
import { isDataState } from '../../../store/data/state';
import { useAppSelector } from '../../../store/hooks';
import ManagementDecorator from '../ManagementDecorator';
import { values } from '../../../utils/record';

function SiteList(_: object, ref: LegacyRef<HTMLDivElement>): JSX.Element {
  // Retrieve sites data.
  const sites = useAppSelector((state) => state.data_slice.externals.sites);

  // Retrieve projects data.
  const projects = useAppSelector(
    (state) => state.data_slice.externals.projects
  );

  // Retrieve associaton data.
  const projectsSiteAssociation = useAppSelector(
    (state) => state.data_slice.externals.project_sites
  );

  const navigate = useNavigate();
  const refresh = () => {
    navigate(0);
  };

  return ManagementDecorator(ref, () =>
    StateDecorator([sites, projectsSiteAssociation, projects], ref, () => {
      assert(isDataState(sites));
      assert(isDataState(projects));
      assert(isDataState(projectsSiteAssociation));

      return (
        <FilteredSites
          sites={values(sites.data)}
          projects={projects}
          projectsSiteAssociation={projectsSiteAssociation}
          refresh={refresh}
        />
      );
    })
  );
}

export default forwardRef(SiteList);
